export class Numbers {
  static formatFloat(value) {
    const num = parseFloat(value) || 0.0;
    const formatted = Number(num.toFixed(2));
    return formatted.toLocaleString("pt-BR");
  }

  static formatInt(value) {
    return Math.round(parseFloat(value) || 0).toLocaleString("pt-BR");
  }

  static formatPercent(value) {
    return `${Numbers.formatFloat(value)}%`;
  }

  static onlyDigits(value) {
    return (value || "").replace(/[()\s-]/g, "").trim();
  }

  static currency(value) {
    return (parseFloat(value) || 0.0).toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }

  static percent(value, precision = 2) {
    const num = parseFloat(value);

    if (isNaN(num)) return "0%";

    const factor = 10 ** precision;
    const rounded = Math.round(num * factor) / factor;

    return `${rounded.toLocaleString("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: precision,
    })}%`;
  }

  static number(value, precision = 2) {
    return (parseFloat(value) || 0.0).toLocaleString("pt-br", {
      maximumFractionDigits: precision,
    });
  }

  static round(value, precision = 2) {
    const res =
      Math.round((value + Number.EPSILON) * Math.pow(10, precision)) /
      Math.pow(10, precision);
    return res;
  }
}
